<template>
  <div class="pageRoot linkListPage collectionModule">
    <div class="pageShell" ref="pageCard">
      <div ref="pageCardMain" class="pageShell__main">
        <div
          ref="scrollArea"
          class="pageShell__scroll"
          :class="{ 'pageShell__scroll--drawerOpen': filterDrawerOpen }"
        >
          <div
            class="listWorkspace"
            :class="{ 'listWorkspace--scrolled': controlBarScrolled }"
          >
            <section
              ref="filterAnchor"
              class="filterCard filterAnchor"
              :class="{ 'filterAnchor--drawerOpen': filterDrawerOpen }"
            >
              <tag-list-filter-panel
                v-bind="filterPanelProps"
                v-on="filterPanelListeners"
              />
            </section>

            <section
              ref="tableZone"
              class="tableCard tableZone"
              :class="{ 'tableCard--scrolled': controlBarScrolled }"
            >
              <div
                class="scrollControlBar"
                :class="{ 'scrollControlBar--scrolled': controlBarScrolled }"
              >
                <div class="scrollControlBar__lead">
                  <span class="scrollControlBar__label">共</span>
                  <strong class="scrollControlBar__count">{{ listTotalCount }}</strong>
                  <span class="scrollControlBar__label">条</span>
                </div>

                <div
                  v-if="!controlBarScrolled"
                  class="scrollControlBar__stage scrollControlBar__stage--full"
                >
                  <control-bar-display
                    layout="info"
                    :scope-filters="activeScopeFilters"
                    :has-active-scope-filters="hasActiveScopeFilters"
                    :scope-filter-tooltip="scopeFilterTooltip"
                    :selection-count="0"
                    @open-filter="openFilterDrawer"
                  />
                </div>

                <template v-else>
                  <div class="scrollControlBar__stage scrollControlBar__stage--left">
                    <control-bar-display
                      part="info"
                      layout="info"
                      :scope-filters="activeScopeFilters"
                      :has-active-scope-filters="hasActiveScopeFilters"
                      :scope-filter-tooltip="scopeFilterTooltip"
                      :selection-count="0"
                      @open-filter="openFilterDrawer"
                    />
                  </div>
                  <div class="scrollControlBar__navSlot">
                    <control-bar-nav
                      @scroll-top="scrollToTableTop"
                      @open-filter="openFilterDrawer"
                    />
                  </div>
                  <div class="scrollControlBar__stage scrollControlBar__stage--right" />
                </template>

                <div class="scrollControlBar__page">
                  <template v-if="listTotalCount > 0">
                    <span>第 {{ listRangeStart }}–{{ listRangeEnd }} 条</span>
                    <span class="scrollControlBar__metaSep" aria-hidden="true">·</span>
                    <span>第 {{ currentPage }} / {{ totalPages }} 页</span>
                  </template>
                  <template v-else>
                    <span class="scrollControlBar__emptyHint">暂无数据</span>
                    <span class="scrollControlBar__metaSep" aria-hidden="true">·</span>
                    <span>第 {{ currentPage }} / {{ totalPages }} 页</span>
                  </template>
                </div>
              </div>

              <div v-if="!loading && tableData.length" class="tableSection">
                <el-table
                  ref="multipleTable"
                  class="linkTable linkTable--hybrid"
                  :data="tableData"
                  tooltip-effect="dark"
                  style="width: 100%"
                  row-key="id"
                >
                  <el-table-column
                    label="标签名称"
                    prop="name"
                    align="center"
                    header-align="center"
                    min-width="140"
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                      <word-copy>{{ scope.row.name }}</word-copy>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="标签 Title"
                    prop="title"
                    align="center"
                    header-align="center"
                    min-width="140"
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                      <span class="cellMuted">{{ scope.row.title || '—' }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="层级"
                    align="center"
                    header-align="center"
                    width="88"
                  >
                    <template slot-scope="scope">
                      <span
                        class="typeTag"
                        :class="'typeTag--' + getTagLevelVariant(scope.row.parentId)"
                      >
                        {{ getTagLevelLabel(scope.row.parentId) }}
                      </span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="所属一级标签"
                    prop="parentName"
                    align="center"
                    header-align="center"
                    min-width="120"
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                      <span
                        class="typeTag"
                        :class="'typeTag--' + getParentTagVariant(scope.row.parentId)"
                      >
                        {{
                          formatParentTagLabel(scope.row.parentName, scope.row.parentId)
                        }}
                      </span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="更新时间"
                    prop="updateTime"
                    align="center"
                    header-align="center"
                    min-width="160"
                    show-overflow-tooltip
                  />
                  <el-table-column
                    label="操作"
                    label-class-name="linkListActionColumnHead"
                    align="center"
                    header-align="center"
                    width="260"
                    class-name="actionColumn"
                  >
                    <template slot="header">
                      <span class="linkListActionColumnHead__label">操作</span>
                    </template>
                    <template slot-scope="scope">
                      <div class="linkTableActionCell">
                        <el-button
                          size="small"
                          class="rowActionBtn rowActionBtn--ghost"
                          icon="el-icon-view"
                          @click.stop="lookInfo(scope.row.id)"
                        >
                          查看
                        </el-button>
                        <el-button
                          v-if="showActions"
                          size="small"
                          class="rowActionBtn rowActionBtn--ghost"
                          icon="el-icon-edit"
                          v-check-role
                          @click.stop="openEdit(scope.row.id)"
                        >
                          编辑
                        </el-button>
                        <el-button
                          v-if="showActions"
                          size="small"
                          class="rowActionBtn rowActionBtn--ghost rowActionBtn--danger"
                          icon="el-icon-delete"
                          v-check-role
                          @click.stop="deleteTagRow(scope.row.id)"
                        >
                          删除
                        </el-button>
                      </div>
                    </template>
                  </el-table-column>
                </el-table>
              </div>

              <div v-else-if="!loading && !tableData.length" class="tableEmpty">
                <div class="tableEmpty__icon"><i class="el-icon-price-tag" /></div>
                <p class="tableEmpty__title">暂无标签</p>
                <p class="tableEmpty__desc">调整筛选条件或新增标签。</p>
                <el-button
                  type="primary"
                  size="small"
                  v-check-role
                  @click="dialogOpen()"
                >
                  新增标签
                </el-button>
              </div>

              <div v-else class="tableSkeletonWrap">
                <el-skeleton :rows="8" animated />
              </div>
            </section>
          </div>
        </div>

        <div
          v-if="filterDrawerOpen"
          class="filterDrawerLayer"
          role="dialog"
          aria-modal="true"
          aria-label="筛选与操作"
        >
          <div
            class="filterDrawerPanel"
            :class="{ 'filterDrawerPanel--scrollable': drawerPanelScrollable }"
            :style="drawerPanelStyle"
          >
            <div class="filterDrawerPanel__header">
              <span class="filterDrawerPanel__title">筛选与操作</span>
              <div class="filterDrawerPanel__headerActions">
                <span v-if="activeFilterCount" class="filterDrawerPanel__chip">
                  已筛选 {{ activeFilterCount }} 项
                </span>
                <button
                  type="button"
                  class="filterDrawerPanel__closeBtn"
                  @click="closeFilterDrawer"
                >
                  收起
                </button>
              </div>
            </div>
            <div ref="drawerScroll" class="filterDrawerPanel__scroll">
              <tag-list-filter-panel
                v-bind="{ ...filterPanelProps, showPanelSummary: true }"
                v-on="filterPanelListeners"
              />
            </div>
          </div>
          <div
            class="filterDrawerBackdrop"
            aria-hidden="true"
            @click="closeFilterDrawer"
            @wheel.prevent
          />
        </div>
      </div>

      <div class="pageShell__footer tableCard__footer footerBar">
        <div class="footerSummary">
          共 <strong class="footerSummary__count">{{ listTotalCount }}</strong> 条 · 第
          {{ currentPage }} / {{ totalPages }} 页
        </div>
        <el-pagination
          class="linkPagination"
          layout="prev, pager, next, sizes, jumper"
          :total="listTotalCount"
          :page-sizes="[25, 50, 100]"
          :page-size="currentPageSize"
          :current-page.sync="currentPage"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </div>
    </div>

    <tag-form-dialog
      :visible.sync="dialogVisible"
      :loading="dialogLoading"
      :mode="nowStatus"
      :rule-form="ruleForm"
      :rules="rules"
      @close="handleClose"
      @submit="submit"
    />
  </div>
</template>

<script>
import {
  createTag,
  deleteTagById,
  getPageList,
  getTagById,
  updateTag,
  getAllTag,
} from '../../../api/tagManage'
import TagListFilterPanel from './TagListFilterPanel.vue'
import TagFormDialog from './TagFormDialog.vue'
import ControlBarDisplay from '../../resourceManage/genericResourceManage/ControlBarDisplay.vue'
import ControlBarNav from '../../resourceManage/genericResourceManage/ControlBarNav.vue'
import linkListScrollControlMixin from '../../resourceManage/genericResourceManage/linkListScrollControlMixin'
import {
  formatParentTagLabel,
  getParentTagVariant,
  getTagLevelLabel,
  getTagLevelVariant,
} from './tagListHelpers'

const TOP_LEVEL_PARENT_OPTION = { id: 0, name: '一级标签' }

export default {
  name: 'TagManageIndex',
  components: {
    TagListFilterPanel,
    TagFormDialog,
    ControlBarDisplay,
    ControlBarNav,
  },
  mixins: [linkListScrollControlMixin],
  data() {
    return {
      name: '',
      parentId: '',
      tableData: [],
      currentPage: 1,
      currentPageSize: 25,
      total: 0,
      loading: false,
      parentFilterOptions: [TOP_LEVEL_PARENT_OPTION],
      levelOneTags: [],
      dialogVisible: false,
      ruleForm: {
        name: '',
        title: '',
        parentId: 0,
      },
      rules: {
        name: [{ required: true, message: '标签名称不能为空', trigger: 'blur' }],
        title: [{ required: true, message: '标签 Title 不能为空', trigger: 'blur' }],
      },
      /** 0 创建，1 查看，2 编辑 */
      nowStatus: 0,
      dialogLoading: false,
      id: '',
      multipleSelection: [],
    }
  },
  computed: {
    showActions() {
      return this.$route.meta.role == 2
    },
    listTotalCount() {
      const parsed = Number(this.total)
      return Number.isFinite(parsed) ? parsed : 0
    },
    listRangeStart() {
      if (this.listTotalCount === 0) return 0
      return (this.currentPage - 1) * this.currentPageSize + 1
    },
    listRangeEnd() {
      if (this.listTotalCount === 0) return 0
      return Math.min(this.currentPage * this.currentPageSize, this.listTotalCount)
    },
    totalPages() {
      if (this.listTotalCount === 0) return 1
      return Math.max(1, Math.ceil(this.listTotalCount / this.currentPageSize))
    },
    activeFilterCount() {
      return [this.name, this.parentId].filter(
        (value) => value !== '' && value !== null && value !== undefined
      ).length
    },
    activeScopeFilters() {
      const chips = []
      if (String(this.name || '').trim()) {
        chips.push({ key: 'name', label: '标签名称', value: this.name.trim() })
      }
      if (this.parentId !== '' && this.parentId != null) {
        chips.push({
          key: 'parentId',
          label: '所属一级标签',
          value: this.resolveParentLabel(this.parentId),
        })
      }
      return chips
    },
    hasActiveScopeFilters() {
      return this.activeScopeFilters.length > 0
    },
    scopeFilterTooltip() {
      return this.activeScopeFilters
        .map((item) => `${item.label}: ${item.value}`)
        .join(' · ')
    },
    filterPanelProps() {
      return {
        name: this.name,
        parentId: this.parentId,
        activeFilterCount: this.activeFilterCount,
        parentOptions: this.parentFilterOptions,
        panelTotalCount: this.listTotalCount,
      }
    },
    filterPanelListeners() {
      return {
        search: this.search,
        'go-create': () => this.dialogOpen(),
        'reset-filters': this.resetFilters,
        'reset-and-search': this.resetAndSearch,
        'update:name': (value) => {
          this.name = value
        },
        'update:parentId': (value) => {
          this.parentId = value
        },
      }
    },
  },
  watch: {
    loading(value) {
      if (!value) {
        this.onLinkListDataRendered()
      } else {
        this.$nextTick(() => {
          this.measureTableZoneWidth()
        })
      }
    },
    tableData() {
      this.$nextTick(() => {
        this.remeasureFilterBlockHeight()
        this.updateScrollControls()
        this.scheduleTableLayout()
      })
    },
    filterDrawerOpen(isOpen) {
      if (isOpen) {
        this.$nextTick(() => {
          this.syncDrawerLayout()
        })
      }
    },
  },
  created() {
    this.bindLinkListScrollControl()
    this.loadParentOptions()
    this.getList()
  },
  methods: {
    getParentTagVariant,
    formatParentTagLabel,
    getTagLevelLabel,
    getTagLevelVariant,
    loadParentOptions() {
      getAllTag({ parentId: 0 })
        .then((res) => {
          if (res.success) {
            const levelOneTags = res.data || []
            this.levelOneTags = levelOneTags
            this.parentFilterOptions = [TOP_LEVEL_PARENT_OPTION, ...levelOneTags]
          }
        })
        .catch((err) => {
          this.$message.error(String(err))
        })
    },
    getList() {
      this.loading = true
      getPageList({
        currentPage: this.currentPage,
        currentPageSize: this.currentPageSize,
        name: this.name,
        parentId: this.parentId,
      })
        .then((res) => {
          if (res.success) {
            this.total = res.total
            this.tableData = res.data || []
          }
        })
        .finally(() => {
          this.loading = false
          this.$nextTick(() => {
            this.measureTableZoneWidth()
            this.scheduleTableLayout()
          })
        })
    },
    search() {
      this.currentPage = 1
      this.getList()
    },
    resetFilters() {
      this.name = ''
      this.parentId = ''
    },
    resetAndSearch() {
      this.resetFilters()
      this.search()
    },
    handleSizeChange(val) {
      this.currentPageSize = val
      this.$nextTick(() => {
        this.getList()
      })
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getList()
    },
    resolveParentLabel(parentId) {
      const match = (this.parentFilterOptions || []).find(
        (item) => String(item.id) === String(parentId)
      )
      return (match && match.name) || String(parentId)
    },
    openEdit(id) {
      this.id = id
      this.dialogOpen(id)
      this.nowStatus = 2
    },
    lookInfo(id) {
      const row = (this.tableData || []).find((item) => String(item.id) === String(id))
      this.id = id
      this.dialogOpen(id, row ? { parentName: row.parentName } : null)
    },
    handleClose() {
      this.ruleForm = {
        name: '',
        title: '',
        parentId: 0,
      }
      this.id = ''
      this.dialogVisible = false
    },
    dialogOpen(id = '', listPreset = null) {
      if (id) {
        this.nowStatus = 1
        this.dialogLoading = true
        getTagById({ id })
          .then((res) => {
            if (res.success) {
              const data = { ...res.data }
              if (listPreset && listPreset.parentName && !data.parentName) {
                data.parentName = listPreset.parentName
              }
              if (data.parentId == null || data.parentId === '') {
                data.parentId = 0
              }
              if (Number(data.parentId) > 0 && !data.parentName) {
                data.parentName = this.resolveParentLabel(data.parentId)
              }
              this.ruleForm = data
            }
          })
          .finally(() => {
            this.dialogLoading = false
          })
      } else {
        this.nowStatus = 0
        this.ruleForm = {
          name: '',
          title: '',
          parentId: 0,
        }
      }
      this.dialogVisible = true
    },
    deleteTagRow(id) {
      this.$confirm('此操作将永久删除该标签，是否继续？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => deleteTagById({ id }))
        .then((res) => {
          if (res.success) {
            this.$message.success('删除成功')
            this.getList()
            this.loadParentOptions()
          }
        })
        .catch(() => {})
    },
    submit() {
      const payload = { ...this.ruleForm }
      const isSecondLevel = Number(payload.parentId) > 0
      if (!isSecondLevel) {
        payload.parentId = 0
      }
      const isCreate = this.nowStatus === 0
      const request = isCreate
        ? createTag({ tagCO: payload })
        : updateTag({ tagCO: { ...payload, id: this.id } })
      if (this.nowStatus !== 0 && this.nowStatus !== 2) {
        return
      }
      request.then((res) => {
        if (res.success) {
          this.$message.success(isCreate ? '新建成功' : '保存成功')
          this.handleClose()
          this.getList()
          this.loadParentOptions()
        }
      })
    },
  },
}
</script>

<style scoped>
.cellMuted {
  color: var(--link-ink-secondary);
}
</style>
